import { projectService } from '@/core/project/services/project.service'
import { useProjectStore } from '@/core/project/store/project.store'
import { useEffect } from 'react'
import { Outlet, useParams } from 'react-router-dom'

export const ProjectProvider = ({ children }: { children?: React.ReactNode }) => {
    const { project_id } = useParams()
    const { project, setProject } = useProjectStore()

    useEffect(() => {
        const loadProject = async () => {
            if (!project_id) return
            console.log('Loading project', project)
            const fetchedProject = await projectService.get(project_id)
            if (fetchedProject) {
                setProject(fetchedProject)
            }
        }
        loadProject()
    }, [project_id, setProject])

    if (!project) return null

    return <>{children || <Outlet />}</>
}
